import React from 'react';
import { Icon } from './Icon.js';
export const IconPill2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8 8L16 16", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11.7782 20L20 11.7782C22.1479 9.6303 22.1479 6.1479 20 4.00002C17.8521 1.85214 14.3697 1.85214 12.2218 4.00002L4.00001 12.2218C1.85213 14.3697 1.85213 17.8521 4.00002 20C6.1479 22.1479 9.6303 22.1479 11.7782 20Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPill2.js.map